import { apiSahPricePlans } from '~constants/api';

import { get, post } from '~libs/genericAction';
import { createThunks, Params } from '~libs/reduxUtils';

export const typePrefix = 'sah-price-plan-revisions';

const config = [
  {
    actionType: 'getAll',
    apiPath: (params: Params) => `${apiSahPricePlans}/${params.plan_id}/revisions`,
    method: get,
  },
  { actionType: 'getOne', apiPath: (params: Params) => `${apiSahPricePlans}/revisions/${params.id}`, method: get },
  {
    actionType: 'create',
    apiPath: (params: Params) => `${apiSahPricePlans}/${params.plan_id}/revisions`,
    method: post,
  },
];

export const { getAll, getOne, create } = createThunks(typePrefix, config);
